export enum WarrantiesUuidEnum {
  RCA = '1000_1530',
  MASSIMALE = '1500_200',
  PROTEZIONE_BONUS = '1500_230',
  CONDUCENTE_TIPO_GUIDA = '1500_240',
  PROTEZIONE_RIVALSA = '1500_251',
  URTO_VEICOLI_NON_ASSICURATI = '1500_252',
  ACCORDO_RISARCIMENTO = '1500_265',
  TUTELA_GIUDIZIARIA = '4000',
  ASSISTENZA = '4200',
  ASSISTENZA_AUTO = '4200I',
  RAPID_REPAIR = '4350',
  GARANZIE = '5300',
  INFORTUNI = '7200',
  SPESE_MEDICHE = '7600',
  VEHICLE_MANUFACTURER = 'v003',
  VEHICLE_MODEL = 'v004',
  VEHICLE_PLATE = 'v001',
}
